import React from "react"
import Helmet from "react-helmet"
import { withPreview } from "gatsby-source-prismic"
import SliceZone from "../components/SliceZone"
import VideoHero from "../components/VideoHero"

const IndexPage = ({
  // doc,
  location,
  data: {
    page,
    events,
    faq,
    gallery,
    steps,
    callouts,
    team,
    donate_form,
  },
}) => {

  return (
    <>
      <Helmet
        bodyAttributes={{
          class: "index page-index",
        }}
      />
      <VideoHero
        page={page}
        // video={require("../assets/kk-highlight.mp4")}
        // logo={require("../assets/gatsby-icon.png")}
        // title="Lets make the world better together"
        // text="The Kyle Kuzma Foundation is a nonprofit organization which is focused on impacting the lives of children, young adults, and families though sports, education, and important life lessons."
        video={page.data.video.url}
        title={page.data.page_title.text}
      />
      
      <SliceZone
          slices={page.data.body}
          page={page}
          faq={faq}
          events={events}
          gallery={gallery}
          steps={steps}
          callouts={callouts}
          team={team}
          donate_form={donate_form}
        />
      
    </>
  )
}

// export default IndexPage
export default withPreview(IndexPage)

export const pageQuery = graphql`
  query  {
    page: prismicHomepage {
      id
      uid
      prismicId
      data {
        page_title {
          text
        }
        video {
          url
        }
        body {
          ... on PrismicHomepageBodyVideoHero {
            id
            slice_type
            primary {
              text {
                text
              }
              title {
                text
              }
              video {
                url
              }
            }
          }
          ... on PrismicHomepageBodyMissionStatement {
            id
            primary {
              text {
                text
              }
              title {
                text
              }
            }
            slice_type
          }
          ... on PrismicHomepageBodyGallerySlider {
            id
            slice_type
            primary {
              title {
                text
              }
            }
          }
          ... on PrismicHomepageBodyEvents {
            id
            slice_type
            primary {
              title {
                text
              }
            }
          }
          ... on PrismicHomepageBodyCallToAction {
            id
            slice_type
            primary {
              media_file {
                url
              }
              link {
                url
                uid
              }
            }
          }
          ... on PrismicHomepageBodyFaq {
            id
            slice_type
            primary {
              title {
                text
              }
            }
          }
          ... on PrismicHomepageBodyCallouts {
            id
            slice_type
            primary {
              title {
                text
              }
            }
          }
          ... on PrismicHomepageBodyImageBlock {
            id
            slice_type
            primary {
              image {
                thumbnails {
                  Mobile {
                    url
                  }
                  Tablet {
                    url
                  }
                  Desktop {
                    url
                  }
                }
              }
              title {
                text
              }
            }
          }
          ... on PrismicHomepageBodyMarquee {
            id
            slice_type
            items {
              text {
                text
              }
            }
          }
          ... on PrismicHomepageBodyTwoColumnBlock {
            id
            slice_type
            primary {
              title {
                text
              }
              media {
                url
              }
            }
          }
          ... on PrismicHomepageBodyDonateForm {
            id
            slice_type
            primary {
              title {
                text
              }
              blurb {
                text
              }
            }
          }
        }
      }
    }
    events: allPrismicEvent(
      sort: { fields: [first_publication_date], order: DESC }
    ) {
      nodes {
        data {
          title {
            text
          }
          video {
            url
          }
          text {
            text
          }
          featured_image {
            url
          }
          date(formatString: "MM-DD-YY")
        }
        url
        uid
        id
        first_publication_date
      }
    }
    faq: prismicFaq {
      data {
        group {
          answer {
            text
          }
          question {
            text
          }
        }
      }
    }
    gallery: prismicGallery {
      id
      data {
        group {
          image {
            thumbnails {
              Mobile {
                url
                alt
              }
              Desktop {
                url
                alt
              }
              Tablet {
                url
                alt
              }
            }
            url
          }
          caption {
            text
          }
        }
        title {
          text
        }
      }
    }
    steps: prismicSteps {
      data {
        group {
          image {
            url
          }
          text {
            text
          }
          title {
            text
          }
        }
      }
    }
    callouts: prismicCallouts {
      data {
        group {
          title {
            text
          }
          link {
            slug
          }
          image {
            url
          }
          cta {
            text
          }
        }
      }
    }
    donate_form: prismicDonateForm {
      id
      data {
        title {
          text
        }
        blurb {
          text
        }
      }
    }
    team: allPrismicTeamMembers(
      sort: { fields: [first_publication_date], order: ASC }
    ) {
      nodes {
        uid
        url
        first_publication_date(formatString: "MM DD YY")
        last_publication_date(formatString: "MM DD YY")
        data {
          name {
            text
          }
          bio {
            text
          }
          image {
            url
          }
          position {
            text
          }
        }
      }
    }
  }
`
